import Image from 'next/image';
import router from 'next/router';
import ReactMarkdown from 'react-markdown';
import { BoxedCallToActionStyle } from '../../styles/components/country';
import { Button } from '../common/ui';

export interface IBoxedCallToActionProps {
  title?: string;
  text: string;
  button: { text: string; link?: string; action?: () => void | Promise<void> };
  isDark?: boolean;
  isLargeTitle?: boolean;
}

const BoxedCallToAction = (props: IBoxedCallToActionProps) => {
  return (
    <div
      className={`${BoxedCallToActionStyle['boxed-call-to-action']} ${
        props.isDark ? BoxedCallToActionStyle['boxed-call-to-action-dark'] : ''
      } ${
        props.isLargeTitle
          ? BoxedCallToActionStyle['boxed-call-to-action-large-title']
          : ''
      } ${
        props.title
          ? BoxedCallToActionStyle['boxed-call-to-action-with-title']
          : ''
      }`}>
      <div className={BoxedCallToActionStyle['boxed-call-to-action-text']}>
        {props.title ? (
          <h2>{props.title}</h2>
        ) : (
          <ReactMarkdown>{props.text}</ReactMarkdown>
        )}
      </div>
      <div className={BoxedCallToActionStyle['boxed-call-to-action-button']}>
        {props.title ? <ReactMarkdown>{props.text}</ReactMarkdown> : null}
        <Button
          color={props.isDark ? 'cta-primary-dark' : 'cta-primary-inverted'}
          hasIcon={props.isDark}
          onClick={() => {
            if (props.button.link) {
              router.push(props.button.link);
            }

            if (props.button.action) {
              props.button.action();
            }
          }}>
          {props.button.text}
          {props.isDark && (
            <Image
              quality={90}
              src={'/assets/images/icons/ChevronRightWhite.svg'}
              alt={'action-button'}
              width={16}
              height={16}
            />
          )}
        </Button>
      </div>
    </div>
  );
};

export default BoxedCallToAction;
